<template>
    <component
        :is="outer"
        :class="[
            'component',
            'component__custom_fields_handler'
        ]"
    >
        <component
            :is="wrapper"
            :class="[`component__custom_fields_handler_fieldset_field`, `component__custom_fields_handler_fieldset_field--${field.type}`]"
            v-for="(field, index) in fieldset"
            :key="toKebabCase(field.name)"
        >
            <component
                :disabled="disabled"
                :key="`${prefix}-component-custom-fields-hanlder-${index}`"
                :is="`form-${formFields[field.type]}`"
                :label="field.name"
                :sub-label="field.subLabel"
                :name="`${prefix}-${field.name}-${index}` | toKebabCase"
                :value="values && values.find(obj => obj.id === field.id) ? values.find(obj => obj.id === field.id).value : ''"
                :items="field.customValidation && field.customValidation.set ? field.customValidation.set.map(obj => {
                    return {
                        label: obj,
                        value: obj
                    }
                 }) : []"
                :width="'full'"
                :multiple="field.type === 'multiple'"
                :required="field.required"
                :v-validate="field.required || field.type === 'alpha' || field.type === 'number' || field.customValidation ? {
                    required: field.required,
                    alpha: field.type === 'alpha',
                    numeric: field.type === 'number',
                    min: field.customValidation && field.customValidation.minLength ? field.customValidation.minLength : false,
                    max: field.customValidation && field.customValidation.maxLength ? field.customValidation.maxLength : false
                } : undefined"
                :data-vv-as="field.name.toLowerCase()"
                @input="emitInput($event, field.id)"
            >{{ field.help }}
            </component>
        </component>
    </component>
</template>

<script>
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import FormSelect from '@/components/default/forms/FormSelect'
import FormText from '@/components/default/forms/FormText'
import FormDate from '@/components/default/forms/FormDate'
import FormNumber from '@/components/default/forms/FormNumber'
import FormEmail from '@/components/default/forms/FormEmail'
import FormPhone from '@/components/default/forms/FormPhone'

export default {
  name: 'component-custom-fields-handler',
  components: {
    FormPhone,
    FormEmail,
    FormNumber,
    FormDate,
    FormText,
    FormSelect,
    FormCheckbox
  },
  data () {
    return {
      formFields: {
        'address': 'text',
        'alpha': 'text',
        'checkbox': 'checkbox',
        'date': 'date',
        'email': 'email',
        'multiple': 'select',
        'number': 'text',
        'numeric': 'text',
        'phone': 'phone',
        'select': 'select',
        'text': 'text'
      }
    }
  },
  props: {
    fieldset: {
      type: Array,
      default: () => []
    },
    values: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outer: {
      type: String,
      default: 'div',
      validator (value) {
        const allowed = ['div', 'table', 'ul']
        return allowed.includes(value)
      }
    },
    wrapper: {
      type: String,
      default: 'div',
      validator (value) {
        const allowed = ['div', 'td', 'li']
        return allowed.includes(value)
      }
    },
    prefix: {
      type: [Number, String],
      default: 'field'
    }
  },
  watch: {
    fieldset (value) {
      this.rerenderIndex++
    }
  },
  methods: {
    emitInput (value, id) {
      if (value.constructor === Array) {
        let object = []
        for (let i = 0; i < value.length; i++) {
          object.push(value[i].value)
        }
        value = object
      } else if (value.constructor === Object) {
        value = value.value
      }
      this.$emit('input', { value, id })
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentcustomfieldshandler";
</style>
